import React, { PureComponent } from 'react';
import Loaders from 'loaders';

class AcceptedView extends PureComponent {
  render() {
    let {
      message,
    } = this.props;


    return (
      <div className="admin-accepted-view page">
        {message ? (
          <p>{message}</p>
        ) : (
          <div>
            <Loaders width="50" height="50"/>
          </div>
        )}
      </div>
    );
  }
}

export default AcceptedView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/OAuth/Accepted/Accepted.view.js